import { schema } from 'normalizr';

export const currenciesInfo = new schema.Entity(
  'currenciesInfo',
  {},
  {
    // name unique among currencies. code, slug are not!
    idAttribute: item => item.name,
    processStrategy: item => ({
      name: item.name,
      code: item.code,
      slug: item.slug,
      type: item.type,
      iso: item.iso,
      title: item.title,
      group: item.group,

      nameG: item.nameG,
      nameP: item.nameP,
      nameGp: item.nameGp,
      nameGp2: item.nameGp2,
      nameAcc: item.nameAcc,
      nameMnps: item.nameMnps,
    }),
  }
);

export const convertorCurrenciesInfo = [currenciesInfo];
